export const ObjectHelper = {
  cleanSquareBrackets: (obj: any): any => {
    if (typeof obj === "object" && obj !== null) {
      // Create a new object or array depending on the input type
      let cleanedObj: any = Array.isArray(obj) ? [] : {};

      // If it's an object, iterate through its keys
      for (let key in obj) {
        if (typeof obj[key] === "string") {
          // If the value is a string, remove text inside square brackets
          cleanedObj[key] = obj[key].replace(/\[.*?\]/g, "");
        } else {
          // Recursively call the function for nested objects or arrays
          cleanedObj[key] = ObjectHelper.cleanSquareBrackets(obj[key]);
        }
      }
      return cleanedObj;
    } else if (Array.isArray(obj)) {
      // If it's an array, create a new array and iterate through it
      return obj.map((item) => ObjectHelper.cleanSquareBrackets(item));
    } else {
      // If it's not an object or array, just return the value (shouldn't happen in typical JSON objects)
      return obj;
    }
  },

  cleanSpecialBrackets: (obj: any): any => {
    const regex = /#\*\[[^\]]*\]\*#/g; // Corrected regex to match #*[content]*#

    if (typeof obj === "object" && obj !== null) {
      let cleanedObj: any = Array.isArray(obj) ? [] : {};

      for (let key in obj) {
        if (typeof obj[key] === "string") {
          //
          const match = obj[key].match(regex);
          //
          if (match) {
            cleanedObj[key] = obj[key].replace(regex, "");
          }
          // Replace brackets only when enclosed in #* and *#
        } else {
          // Recursively call the function for nested objects or arrays
          cleanedObj[key] = ObjectHelper.cleanSpecialBrackets(obj[key]);
        }
      }
      return cleanedObj;
    } else if (Array.isArray(obj)) {
      return obj.map((item) => ObjectHelper.cleanSpecialBrackets(item));
    } else {
      return obj; // If it's neither object nor array, just return the value
    }
  },

  stripNulls<T>(obj: T): T | null {
    if (obj === null || obj === undefined) {
      return null;
    }

    if (Array.isArray(obj)) {
      // Clean each item but keep empty arrays intact
      return obj.map((item) => ObjectHelper.stripNulls(item)) as any;
    }

    if (typeof obj === "object") {
      if (obj instanceof Date) {
        return obj;
      }

      // recurivily clean each object property without a reducer

      const cleanedObject = Object.entries(obj).reduce((acc, [key, value]) => {
        const cleanedValue = ObjectHelper.stripNulls(value);
        if (cleanedValue !== null) {
          acc[key] = cleanedValue;
        }
        return acc;
      }, {} as any);

      // Remove object if it is empty
      return Object.keys(cleanedObject).length > 0 ? cleanedObject : null;
    }

    return obj;
  }
};
